var exports = {
  "aZ": "SingleSelectToken__WYEe_H",
  "HG": "Interactive__gXRdNH",
  "AX": "NonInteractive__IhPOLM",
};

module.exports = exports;
